/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SamOfferProductDetailsResponseDtoDto } from '../models/sam-offer-product-details-response-dto-dto';


/**
 * the QueryOfferProductDetails API
 */
@Injectable({
  providedIn: 'root',
})
export class QueryOfferProductDetailsService extends BaseService {
  constructor(
    config: SalesApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation queryOfferProductDetails
   */
  static readonly QueryOfferProductDetailsPath = '/draft/{offerId}/product/details';

  /**
   * Read product details for the offer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryOfferProductDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  queryOfferProductDetails$Response(params: {
    offerId: string;

    /**
     * Language
     */
    language: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamOfferProductDetailsResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, QueryOfferProductDetailsService.QueryOfferProductDetailsPath, 'get');
    if (params) {
      rb.path('offerId', params.offerId, {});
      rb.query('language', params.language, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamOfferProductDetailsResponseDtoDto>;
      })
    );
  }

  /**
   * Read product details for the offer
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryOfferProductDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queryOfferProductDetails(params: {
    offerId: string;

    /**
     * Language
     */
    language: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<SamOfferProductDetailsResponseDtoDto> {

    return this.queryOfferProductDetails$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamOfferProductDetailsResponseDtoDto>) => r.body as SamOfferProductDetailsResponseDtoDto)
    );
  }

}
